import { readonly, shallowRef } from 'vue';

export type ToastTone = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  tone: ToastTone;
  message: string;
}

const items = shallowRef<Toast[]>([]);
let nextId = 1;

/** Avisos curtos na tela. Estado compartilhado: qualquer componente chama `useToasts().push(...)` e o `DdtToastHost` mostra. */
export function useToasts() {
  function dismiss(id: number): void {
    items.value = items.value.filter((t) => t.id !== id);
  }

  function push(message: string, tone: ToastTone = 'info', durationMs = 5000): number {
    const id = nextId++;
    items.value = [...items.value, { id, tone, message }].slice(-5);
    if (durationMs > 0) setTimeout(() => dismiss(id), durationMs);
    return id;
  }

  return {
    items: readonly(items),
    push,
    dismiss,
    success: (message: string) => push(message, 'success'),
    error: (message: string) => push(message, 'error', 8000),
    clear: () => {
      items.value = [];
    },
  };
}
